import {
  Lightbulb,
  ClipboardCheck,
  Users,
  BarChart3,
  Bell,
  Shield,
} from "lucide-react";
import type { ComponentType } from "react";

interface Tip {
  icon: ComponentType<{ className?: string }>;
  text: string;
}

const TIPS: Tip[] = [
  {
    icon: ClipboardCheck,
    text: "Registra las operaciones del día lo antes posible para mantener los reportes actualizados",
  },
  {
    icon: Users,
    text: "Mantén los datos de tus clientes al día para agilizar la gestión diaria",
  },
  {
    icon: BarChart3,
    text: "Revisa los indicadores clave al inicio de cada semana para detectar tendencias",
  },
  {
    icon: Bell,
    text: "Atiende las notificaciones pendientes antes de cerrar el día",
  },
  {
    icon: Shield,
    text: "Verifica que los permisos de tu equipo estén correctamente configurados",
  },
];

export const ActivityTipsCard = () => {
  const visibleTips = TIPS.slice(0, 3);

  return (
    <div className="card-compact flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 rounded-lg bg-global-overlay-secondary border border-global-primary flex items-center justify-center shrink-0">
          <Lightbulb
            className="w-4 h-4 text-global-accent"
            aria-hidden="true"
          />
        </span>
        <div>
          <h2 className="text-size-base font-semibold text-global-title">
            Consejos del Día
          </h2>
          <p className="text-size-xs text-global-muted">
            Buenas prácticas para el equipo
          </p>
        </div>
      </div>

      <ul className="flex flex-col gap-3" role="list">
        {visibleTips.map((tip) => (
          <li key={tip.text} className="flex items-start gap-3 min-w-0">
            <span className="w-7 h-7 rounded-lg bg-global-overlay-secondary border border-global-primary flex items-center justify-center shrink-0 mt-0.5">
              <tip.icon
                className="w-3.5 h-3.5 text-global-accent"
                aria-hidden="true"
              />
            </span>
            <p className="text-size-xs sm:text-size-sm text-global-secondary leading-snug min-w-0 flex-1">
              {tip.text}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};
